export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9755.197f36d8.jpg";